import { c as _c } from "react/compiler-runtime";
import { Box, Button, Grid, HStack } from '@chakra-ui/react';
import { CrmCard } from '@src/components/sco/Admin/AiCrm/ui/CrmSurface';
import { useFillViewport } from '@src/components/sco/Admin/AiCrm/ui/useFillViewport';
import { useContainerBreakpointValue } from '@src/components/sco/utilities/BreakpointProvider';
import React, { type ReactNode, useEffect, useRef } from 'react';
import { LuChevronLeft } from 'react-icons/lu';

/** True when the CRM region is wide enough for a list beside its detail. */
export function useCrmWide() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      base: false,
      lg: true
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useContainerBreakpointValue(t0) === true;
}

/**
 * A list on the left and its detail on the right, each scrolling on its own. Wide regions show both.
 * Narrow ones show the list, or the detail with a way back. `open` says a detail is chosen.
 */
export function CrmSplit(props) {
  const $ = _c(22);
  const wide = useCrmWide();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      bottom: 12,
      min: 560
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    height,
    ref
  } = useFillViewport(t0);
  const detailRef = useRef(null);
  const showList = wide || !props.open;
  const showDetail = wide || props.open;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      detailRef.current?.scrollTo({
        top: 0
      });
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props.detailKey) {
    t2 = [props.detailKey];
    $[2] = props.detailKey;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(t1, t2);
  const t3 = height ? `${height - 12}px` : "640px";
  const t4 = wide ? `${props.listWidth || "340px"} minmax(0, 1fr)` : "1fr";
  let t5;
  if ($[4] !== props.list || $[5] !== showList || $[6] !== wide) {
    t5 = showList ? <Box borderColor="border" borderRightWidth={wide ? "1px" : 0} h="full" minH={0} overflow="hidden">{props.list}</Box> : null;
    $[4] = props.list;
    $[5] = showList;
    $[6] = wide;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== props.backLabel || $[9] !== props.detail || $[10] !== props.onBack || $[11] !== showDetail || $[12] !== wide) {
    t6 = showDetail ? <Box ref={detailRef} bg="colorPalette.panel" h="full" minH={0} minW={0} overflowY="auto">{!wide ? <HStack borderBottomWidth="1px" borderColor="border" px={3} py={2}><Button size="xs" variant="ghost" onClick={props.onBack}><LuChevronLeft /> {props.backLabel || "Back"}</Button></HStack> : null}{props.detail}</Box> : null;
    $[8] = props.backLabel;
    $[9] = props.detail;
    $[10] = props.onBack;
    $[11] = showDetail;
    $[12] = wide;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t4 || $[15] !== t5 || $[16] !== t6) {
    t7 = <Grid h="full" minH={0} templateColumns={t4}>{t5}{t6}</Grid>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== ref || $[19] !== t3 || $[20] !== t7) {
    t8 = <CrmCard ref={ref} border="none" borderRadius={0} h={t3} overflow="hidden">{t7}</CrmCard>;
    $[18] = ref;
    $[19] = t3;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
}